module.exports = function() {
  return new Worker(__webpack_public_path__ + "f22f7acbce0217730dd0.worker.js");
};